import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import '@src/App.scss'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import Routes from '@route/Routes'
import Confirm from '@components/Confirm'
import Alert from '@components/Alert'
import Message from '@components/Message'
import {
  getToken
} from '@store/user'

const theme = createTheme(
  {
    palette: {
      primary: { main: '#6c6c6c' }
    }
  }
)

const App = () => {
  const [ isStartView, setIsStartView ] = useState(false)
  const dispatch = useDispatch()
  const { accessToken, user } = useSelector(store => store.user)

  useEffect(() => {
    async function start() {
      await dispatch(getToken())
      setIsStartView(true)
    }
    if (!isStartView) {
      start()
    }
  }, [ dispatch, isStartView ])

  return (
    <ThemeProvider theme={theme}>
      <div id="app">
        {
          isStartView && <Routes token={accessToken} userRoles={user.roles} />
        }
        <Confirm />
        <Alert />
        <Message />
      </div>
    </ThemeProvider>
  )
}


export default App
